


































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
import dayjs from "dayjs";
import calculate from '@/common/util/calculate';
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class wdStatistics extends Vue {
  timeValue = [];
  /**登陆信息 */
  public userInfo =
    localStorage.getItem("dayChecked") == "true"
      ? JSON.parse(localStorage.getItem("userInfo"))
      : JSON.parse(sessionStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;

  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    start: dayjs(new Date()).subtract(3, "month").format("YYYY-MM-DD") + " 00:00:00",
    end: dayjs(new Date()).format("YYYY-MM-DD") + " 23:59:59",
    skip: 0,
    count: 10,
    goodsKey:"",
    goodsClassId: "",
    saleNumberSort:null,
    sellingTotalAmountSort:null,
    unPickUpNumSort:0,
  };
  exloading = false;
  // 合计
  totalNum=0;
  totalSelling=0;
  totalUnPickUpNum=0;
  fmoney = fmoney;
  //所属分类的name名字总和
  departvalue = [];
  // 所属分类选择
  classOptions: any = [];


  async mounted() {
    this.timeValue = [
      dayjs(new Date()).subtract(3, "month").format("YYYY-MM-DD"),
      dayjs(new Date()).format("YYYY-MM-DD"),
    ];
    await this.getClassList();
    await this.getlist();
    
  }
  activated() {}


  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetOnlineOrderGoodsListToPos(this.searchValue);
    this.listData = result.items.map((v) => {
      return {
        ...v,
      };
    });
    this.total = result.totalCount;
    this.totalNum = result.totalNum;
    this.totalSelling = result.totalSelling;
    this.totalUnPickUpNum = result.totalUnPickUpNum;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  /**商品分类 */
  async getClassList() {
    let res = await Public.GetTbGoodsClassByNameToPos({
      shopId: JSON.parse(localStorage.getItem("userInfo")).shopId
    });
    this.classOptions = res.map((v) => {
      return {
        ...v,
        children: v.items,
      };
    });
  }
  getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    sums[0] = "合计";
    sums[7] = this.totalNum;
    sums[8] = this.totalSelling;
    sums[9] = this.totalUnPickUpNum;
    return sums;
  }
  sortchange(col): void {
    console.log(col);
    if (col.order == "ascending") {
      if (col.prop == "saleNumber") {
        this.searchValue.saleNumberSort = 1;
        this.searchValue.sellingTotalAmountSort = null;
        this.searchValue.unPickUpNumSort = null;
      } else if (col.prop == "sellingTotalAmount") {
        this.searchValue.sellingTotalAmountSort = 1;
        this.searchValue.unPickUpNumSort = null;
        this.searchValue.saleNumberSort = null;
      }
      else if (col.prop == "unPickUpNum") {
        this.searchValue.unPickUpNumSort = 1;
        this.searchValue.sellingTotalAmountSort = null;
        this.searchValue.saleNumberSort = null;
      }
    } else if (col.order == "descending") {
      if (col.prop == "saleNumber") {
        this.searchValue.saleNumberSort = 0;
        this.searchValue.sellingTotalAmountSort = null;
        this.searchValue.unPickUpNumSort = null;
      } else if (col.prop == "sellingTotalAmount") {
        this.searchValue.sellingTotalAmountSort = 0;
        this.searchValue.unPickUpNumSort = null;
        this.searchValue.saleNumberSort = null;
      }
      else if (col.prop == "unPickUpNum") {
        this.searchValue.unPickUpNumSort = 0;
        this.searchValue.sellingTotalAmountSort = null;
        this.searchValue.saleNumberSort = null;
      }
    } else {
      this.searchValue.saleNumberSort = null;
      this.searchValue.sellingTotalAmountSort = null;
      this.searchValue.unPickUpNumSort = 0;
    }
    this.getlist();
  }
  async handleChange(value) {
    if (value.length == 0) {
      const _cascader = this.$refs["cascaderHandle"];
      if (_cascader) {
        _cascader.$refs.panel.checkedValue = [];
        _cascader.$refs.panel.activePath = [];
        _cascader.$refs.panel.syncActivePath();
      }
    }
    if (value.length > 0) {
      console.log(value);
      if (value.length == 1) {
        this.searchValue.goodsClassId = value[0];
      } else {
        this.searchValue.goodsClassId = value[1];
      }
    } else {
      this.searchValue.goodsClassId = "";
    }
    this.$refs["cascaderHandle"].dropDownVisible = false;
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = [
        dayjs(new Date()).subtract(3, "month").format("YYYY-MM-DD"),
        dayjs(new Date()).format("YYYY-MM-DD")
    ];
    this.searchValue = {
        shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
        start: dayjs(new Date()).subtract(3, "month").format("YYYY-MM-DD") + " 00:00:00",
        end: dayjs(new Date()).format("YYYY-MM-DD") + " 23:59:59",
        skip: 0,
        count: 10,
        goodsKey:"",
        goodsClassId: "",
        saleNumberSort:null,
        sellingTotalAmountSort:null,
        unPickUpNumSort:0,
    };
    this.departvalue = [];
    const _cascader = this.$refs["cascaderHandle"];
    if (_cascader) {
      _cascader.$refs.panel.checkedValue = [];
      _cascader.$refs.panel.activePath = [];
      _cascader.$refs.panel.syncActivePath();
    }
    await this.getlist();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }

  /**时间改变 */
  timeChange(val) {
    if (val) {
      this.searchValue.start = val[0] + " 00:00:00";
      this.searchValue.end = val[1] + " 23:59:59";
    } else {
      this.searchValue.start = "";
      this.searchValue.end = "";
    }
  }

  export_table(item) {
    try {
      this.exloading = true;
      Public.GetOnlineOrderGoodsListToPosReport(
        Object.assign({}, this.searchValue, {
          skip: 0,
          count: -1,
        })
      ).then((res) => {
        var fileName = "网店销售统计报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/wdStatistics/index.vue